import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-brand-line bg-brand-bone" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-baseline gap-2">
            <span className="font-serif text-4xl tracking-tight text-brand-ink">WR</span>
            <span className="label-eyebrow text-brand-terracotta">Rishtey</span>
          </div>
          <p className="mt-4 max-w-md text-brand-muted leading-relaxed">
            A curated matchmaking concierge for Muslim families who value deen,
            adab, and lasting companionship. Every profile hand-reviewed.
          </p>
        </div>
        <div>
          <div className="label-eyebrow text-brand-muted mb-4">Company</div>
          <ul className="space-y-2 text-sm text-brand-ink">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-brand-terracotta transition-colors">About</Link></li>
            <li><Link to="/plans" data-testid="footer-membership" className="hover:text-brand-terracotta transition-colors">Membership</Link></li>
            <li><Link to="/stories" data-testid="footer-stories" className="hover:text-brand-terracotta transition-colors">Success Stories</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-brand-terracotta transition-colors">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-brand-muted mb-4">Trust</div>
          <ul className="space-y-2 text-sm text-brand-ink">
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-brand-terracotta transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-brand-terracotta transition-colors">Terms of Use</Link></li>
            <li><Link to="/safe-match" data-testid="footer-safe" className="hover:text-brand-terracotta transition-colors">Safe Match Pledge</Link></li>
            <li><Link to="/refund" data-testid="footer-refund" className="hover:text-brand-terracotta transition-colors">Refund Policy</Link></li>
            <li><Link to="/report" data-testid="footer-report" className="hover:text-brand-terracotta transition-colors">Report an Issue</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-brand-line">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-center justify-between text-xs text-brand-muted">
          <span>© {new Date().getFullYear()} WR Rishtey Enterprise. All rights reserved.</span>
          <span className="mt-2 md:mt-0">Crafted with reverence for deen and adab.</span>
        </div>
      </div>
    </footer>
  );
}
